module.exports = __webpack_public_path__ + "img/ring_0_0_null_null@2x.8d209401.png";